"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIGRATION_011_SERVER_QUICK_ACTIONS = void 0;
/**
 * Migration 011 (server only): per-user quick-action shortcuts stored in
 * Postgres so they sync across devices and survive browser cache clears.
 *
 * Rows are scoped by (tenant_id, user_id) — each user in each tenant has
 * their own independent set of up to 6 shortcuts.
 */
const MIGRATION_011_SQL = `\
CREATE TABLE IF NOT EXISTS omni_quick_actions (
  id         TEXT PRIMARY KEY,
  tenant_id  TEXT NOT NULL,
  user_id    TEXT NOT NULL,
  icon       TEXT NOT NULL,
  label      TEXT NOT NULL,
  prompt     TEXT NOT NULL,
  sort_order INTEGER NOT NULL DEFAULT 0,
  created_at BIGINT NOT NULL
);
CREATE INDEX IF NOT EXISTS idx_omni_quick_actions_user
  ON omni_quick_actions(tenant_id, user_id, sort_order);
`;
exports.MIGRATION_011_SERVER_QUICK_ACTIONS = {
    id: '011_server_quick_actions',
    version: 11,
    name: 'server-side quick-action shortcuts',
    side: 'server',
    sql: MIGRATION_011_SQL,
};
//# sourceMappingURL=011_server_quick_actions.js.map